export interface IProcessList {
	title: string
	text: string
}

export const data: IProcessList[] = [
	{
		title: 'Оставьте заявку',
		text: 'Вы узнаете предварительное решение за полчаса.',
	},
	{
		title: 'Загрузите документы',
		text: 'В личном кабинете не выходя из дома или офиса.',
	},
	{
		title: 'Встретьтесь с менеджером',
		text: 'Наш представитель приедет на объект залога в удобное для вас время, чтобы подписать документы.',
	},
	{
		title: 'Регистрация обременения ',
		text: 'Мы подключились к Росреестру и умеем регистрировать обременение по клику. Никакого томительного ожидания в очередях.',
	},
	{
		title: 'Получите деньги',
		text: 'Мы переводим всю сумму на счёт в любом банке.',
	},
]
